<template>
  <v-container class="mt-4 px-5" fluid>
    <v-row v-if="( getdatosUsuarioERPERP.idpuesto == 31 && getdatosUsuarioERPERP.iderp == 1258 ) || getdatosUsuarioERPERP.idpuesto != 31 ">
      <v-col cols="12">
        <v-card class="shadowCard">
          <v-card-title primary-title class="text-subtitle-1">
            Asignación de contactos
            <v-spacer></v-spacer>

            <v-btn
              color="#FFF800"
              class="mr-2 text-caption"
              @click="dialogBuenSeguimiento.estatus = true"
              small
              tile
              v-if="![1258].includes( getdatosUsuarioERPERP.iderp )"
            >
              <v-img src="@/assets/iconos/secretaria.png" max-width="25" class="mr-2"></v-img>
              Buen Seg.
            </v-btn>

            <v-btn
              color="orange"
              class="mr-2 text-caption"
              dark
              @click="dialogDiferencias.estatus = true"
              small
              tile
              v-if="![3,568,2155,1258,2268,2472,2556,2767].includes( getdatosUsuarioERPERP.iderp )"
            >
              <v-icon small left>mdi-account-convert</v-icon>
              Dif.
            </v-btn>


            <v-btn
              color="yellow"
              class="mr-2 text-caption"
              @click="dialogReporteGoogle.estatus = true"
              small
              tile
              v-if="![3,568,2155,1258,2268,2472,2556,2767].includes( getdatosUsuarioERPERP.iderp )"
            >
              <v-icon small>mdi-google</v-icon>
            </v-btn>


            <v-btn
              color="blue"
              class="mr-2 text-caption"
              dark
              @click="dialogReporte.estatus = true"
              small
              tile
              v-if="![3,568,2155,1258,2268,2472,2556, 2767].includes( getdatosUsuarioERPERP.iderp )"
            >
              <v-icon small>mdi-facebook</v-icon>
            </v-btn>

            <v-btn
              color="pink"
              class="mr-2 text-caption"
              dark
              @click="dialogReporteSucursal.estatus = true"
              small
              tile
              v-if="![1258,2268,2472,2767].includes( getdatosUsuarioERPERP.iderp )"
            >
              <v-icon small left>mdi-chart-bar</v-icon>
              Suc. Interes
            </v-btn>

            <v-btn
              color="brown"
              class="mr-2 text-caption"
              dark
              @click="dialogEfectividad.estatus = true"
              small
              tile
              v-if="![1258,2268,2472].includes( getdatosUsuarioERPERP.iderp )"
            >
              <v-icon small left>mdi-star</v-icon>
              EFECT
            </v-btn>

            <v-btn
              color="green"
              class="mr-2 text-caption"
              dark
              @click="dialogVendedora.estatus = true"
              small
              tile
            >
              <v-icon small left>mdi-account</v-icon>
              Rep.
            </v-btn>

            <!-- Abrir modal para reasignar twilio --> 
            <v-btn
              color="red"
              class="mr-2 text-caption"
              dark
              @click="dialogTwilio.estatus = true"
              small
              tile
              v-if="![2155,1258,2268,2472,2556,2767].includes( getdatosUsuarioERPERP.iderp )"
            >
              <v-icon small left>mdi-account-question</v-icon>
              TW
            </v-btn>

            <v-btn
              color="blue"
              class="mr-2 text-caption"
              dark
              @click="dialogResaginar.estatus = true"
              small
              tile
              v-if="![1258].includes( getdatosUsuarioERPERP.iderp )"
            >
              <v-icon small left>mdi-account-switch</v-icon>
              Reasig.
            </v-btn>


            <v-btn
              color="primary"
              class="mr-2"
              dark
              @click="dialog = true"
              small
              tile
              v-if="![3,568,2155,1258].includes( getdatosUsuarioERPERP.iderp )"
            >
              <v-icon small left>mdi-plus</v-icon>
              LEAD
            </v-btn>

            <v-btn
              color="teal darken-1"
              class="mr-2"
              dark
              @click="dialogEtiquetas = true"
              small
              tile
              v-if="![3,568,2155,1258].includes( getdatosUsuarioERPERP.iderp )"
            >
              <v-icon small left>mdi-tag</v-icon>
              Etiquetas
            </v-btn>

            <v-btn
              color="primary"
              small
              @click="initialize()"
              tile
            >
              <v-icon small>mdi-refresh</v-icon>
            </v-btn>


          </v-card-title>

          <v-card-text>
            <v-row >

              <v-col cols="12">
                <v-radio-group
                  v-model="escuela"
                  row
                  hide-details
                  @change="initialize"
                >
                  <v-radio
                    label="INBI"
                    :value="1"
                  ></v-radio>
                  <v-radio
                    label="FAST"
                    :value="2"
                  ></v-radio>
                </v-radio-group>
              </v-col>
              <v-col cols="12" sm="4" md="4" lg="3" xl="2">
                <v-text-field
                  v-model="fechaini"
                  hide-details
                  dense
                  filled
                  type="date"
                  label="Fecha inicio"
                  clearable
                ></v-text-field>
              </v-col>

              <v-col cols="12" sm="4" md="4" lg="3" xl="2">
                <v-text-field
                  v-model="fechafin"
                  hide-details
                  dense
                  filled
                  type="date"
                  label="Fecha final"
                  clearable
                ></v-text-field>
              </v-col>

              <v-spacer></v-spacer>

              <v-col cols="12" md="6" lg="5">
                <v-text-field
                label="Buscar Prospecto"
                dense
                v-model="search"
                filled
                append-icon="mdi-magnify"
                ></v-text-field>
              </v-col>



              <v-col cols="12" v-if="![1258].includes( getdatosUsuarioERPERP.iderp )">


                <v-row>
                  <v-col cols="12" lg="2" md="3">
                    <v-checkbox
                      v-model="checkGeneral"
                      label="General"
                    ></v-checkbox>
                  </v-col>

                  <v-col cols="12" lg="2" md="3">
                    <v-checkbox
                      v-model="checkCompletos"
                      label="Twilios Completos"
                    ></v-checkbox>
                  </v-col>

                  <v-col cols="12" lg="2" md="3">
                    <v-checkbox
                      v-model="checkIncompletos"
                      label="Twilios Incompletos"
                    ></v-checkbox>
                  </v-col>

                  <v-col cols="12" lg="2" md="3">
                    <v-checkbox
                      v-model="checkMerca"
                      label="Mercadotecnía"
                    ></v-checkbox>
                  </v-col>

                  <v-col cols="12" lg="2" md="3">
                    <v-checkbox
                      v-model="checkSucursal"
                      label="Contactos de sucursal"
                    ></v-checkbox>
                  </v-col>
                </v-row>

                <v-row >
                    <v-btn
                      class="mx-6 p-0"
                      small dark color="green"
                      @click="exportExcel( contadorVendedoras  , 'REPORTE_VENDEDORAS')"
                      tile
                    >
                      <v-icon small>mdi-microsoft-excel</v-icon>
                    </v-btn>

                    <v-col cols="2" class="p-0">
                      <v-select
                        :items="ciudades"
                        v-model="search2"
                        label="Buscar ciudad"
                        filled
                        dense
                        clearable
                      ></v-select>
                    </v-col>


                </v-row>

                <!--Lista de prospectos-->
                <v-data-table

                  :headers="headers2"
                  :items="contadorVendedoras"

                  class="elevation-0"
                  :search="search2"
                  dense
                  id="asignacion"
                >

                  <template v-slot:item.convencimiento="{ item }">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <span
                          color="primary"
                          dark
                          v-bind="attrs"
                          v-on="on"
                        >
                          {{ item.convencimiento }}
                        </span>
                      </template>
                      <span>{{ item.desglose }}</span>
                    </v-tooltip>
                  </template>


                  <template v-slot:item.contactos="{ item }">
                    <v-chip small dense color="primary" dark @click="opZona = 'TODOS', verContactos( item.contactosGeneral )">{{ item.contactos }}</v-chip>
                  </template>

                  <template v-slot:item.completos="{ item }">
                    <v-chip small dense color="primary" dark @click="opZona = 'TODOS', verContactos( item.completos )">{{ item.completos.length }}</v-chip>
                  </template>

                  <template v-slot:item.incompletos="{ item }">
                    <v-chip small dense color="primary" dark @click="opZona = 'TODOS', verContactos( item.incompletos )">{{ item.incompletos.length }}</v-chip>
                  </template>

                  <template v-slot:item.merca="{ item }">
                    <v-chip small dense color="primary" dark @click="opZona = 'TODOS', verContactos( item.merca )">{{ item.merca.length }}</v-chip>
                  </template>

                  <template v-slot:item.sucursal="{ item }">
                    <v-chip small dense color="primary" dark @click="opZona = 'TODOS', verContactos( item.sucursal )">{{ item.sucursal.length }}</v-chip>
                  </template>

                  <template v-slot:item.inscritos="{ item }">
                    <v-chip small dense color="primary" dark @click="verInscritos( item.inscritos_detalle )">{{ item.inscritos }}</v-chip>
                  </template>

                  <template v-slot:item.inscritosCompletos="{ item }">
                    <v-chip small dense color="primary" dark @click="verInscritos( item.inscritosCompletos )">{{ item.inscritosCompletos.length }}</v-chip>
                  </template>

                  <template v-slot:item.inscritosIncompletos="{ item }">
                    <v-chip small dense color="primary" dark @click="verInscritos( item.inscritosIncompletos )">{{ item.inscritosIncompletos.length }}</v-chip>
                  </template>

                  <template v-slot:item.inscritosMerca="{ item }">
                    <v-chip small dense color="primary" dark @click="verInscritos( item.inscritosMerca )">{{ item.inscritosMerca.length }}</v-chip>
                  </template>

                  <template v-slot:item.inscritosSucursal="{ item }">
                    <v-chip small dense color="primary" dark @click="verInscritos( item.inscritosSucursal )">{{ item.inscritosSucursal.length }}</v-chip>
                  </template>

                  <template v-slot:item.inscritos_fecha="{ item }">
                    <v-chip small dense color="primary" dark @click="verInscritos( item.inscritos_fecha )">{{ item.inscritos_fecha.length }}</v-chip>
                  </template>

                  <template v-slot:item.calidad="{ item }">

                    <!-- {{ ( item.completos.length / item.contactos ) * 100 }} -->

                    <v-chip
                      :color="
                        ( item.completos.length / item.contactos ) * 100 > 70
                          ? 'green'
                          : ( item.completos.length / item.contactos ) * 100 > 50
                          ? 'orange'
                          : ( item.completos.length / item.contactos ) * 100 > 31 ?
                          'red'
                          : 'purple'
                      "
                      small
                      dark
                    >
                      {{
      ( item.completos.length / item.contactos ) * 100 >= 70
        ? 'Buena'
        : ( item.completos.length / item.contactos ) * 100 >= 50
        ? 'Regular'
        : ( item.completos.length / item.contactos ) * 100 >= 31
        ? 'Mala'
        : 'Pesima'
    }}
                    </v-chip>
                  </template>

                   <template v-slot:body.append>
                    <tr class="font-weight-bold grey lighten-3" v-for="(total, indexTotal) in filasTotales" :key="indexTotal">
                      <td></td>
                      <td><strong>TOTAL</strong></td>
                      <td><strong>{{ total.estado }}</strong></td>
                      <td></td>
                      <td></td>
                     <td>
                        <v-chip :color="!total.contactos ? 'grey' : (total.completos.length / total.contactos) * 100 > 70
                            ? 'green'
                            : (total.completos.length / total.contactos) * 100 > 50
                              ? 'orange'
                              : (total.completos.length / total.contactos) * 100 > 31 ?
                                'red'
                                : 'purple'
                          " small dark>
                          {{
                            !total.contactos
                              ? '—'
                              : (total.completos.length / total.contactos) * 100 >= 70
                              ? 'Buena'
                              : (total.completos.length / total.contactos) * 100 >= 50
                                ? 'Regular'
                                : (total.completos.length / total.contactos ) * 100 >= 31
                          ? 'Mala'
                          : 'Pesima'
                          }}
                        </v-chip>
                      </td>
                      <!-- <td>
                        <v-chip small dense color="primary" dark @click="verInscritos(total.inscritos_fecha)">{{
                          total.inscritos_fecha.length }}</v-chip>
                      </td> -->
                      <td>
                        <v-chip small dense color="primary" dark
                          @click="opZona = 'TODOS', verContactos(total.contactosall)">{{ total.contactos }}</v-chip>
                      </td>
                      <!-- <td>
                        <v-chip small dense color="primary" dark @click="verInscritos(total.inscritos_detalle)">{{
                          total.inscritos }}</v-chip>
                      </td> -->

                      <td>
                        <v-chip small dense color="primary" dark @click="verInscritos(total.inscritos_detalle)">{{
                          total.inscritos }}</v-chip>
                      </td> 
                      
                      <td align="end">{{ total.convencimiento }}</td>

                      <td>
                        <v-chip small dense color="primary" dark
                          @click="opZona = 'TODOS', verContactos(total.completos)">{{ total.completos.length }}</v-chip>
                      </td>

                      <td>
                        <v-chip small dense color="primary" dark @click="verInscritos(total.inscritosCompletos)">{{
                          total.inscritosCompletos.length }}</v-chip>
                      </td>

                      <td align="end">{{ total.convencimientoCompletos }}</td>

                      <td>
                        <v-chip small dense color="primary" dark
                          @click="opZona = 'TODOS', verContactos(total.incompletos)">{{ total.incompletos.length
                          }}</v-chip>
                      </td>

                      <td>
                        <v-chip small dense color="primary" dark @click="verInscritos(total.inscritosIncompletos)">{{
                          total.inscritosIncompletos.length }}</v-chip>
                      </td>

                      <td align="end"> {{ total.convencimientoIncompletos }}</td>

                      <td>
                        <v-chip small dense color="primary" dark @click="verInscritos(total.merca)">{{
                          total.merca.length }}</v-chip>
                      </td>

                      <td>
                        <v-chip small dense color="primary" dark @click="verInscritos(total.inscritosMerca)">{{
                          total.inscritosMerca.length }}</v-chip>
                      </td>

                      <td align="end"> {{ total.convencimientoMerca }}</td>


                      <td>
                        <v-chip small dense color="primary" dark
                          @click="opZona = 'TODOS', verContactos(total.sucursal)">{{ total.sucursal.length }}</v-chip>
                      </td>

                      <td>
                        <v-chip small dense color="primary" dark @click="verInscritos(total.inscritosSucursal)">{{
                          total.inscritosSucursal.length }}</v-chip>
                      </td>

                      <td align="center"> {{ total.convencimientoSucursal }}</td>

                    </tr>
                  </template>

                </v-data-table>

              </v-col>
            </v-row>

            <v-row  v-if="![1258].includes( getdatosUsuarioERPERP.iderp )">
              <v-col cols="12">
                <v-btn
                  class="mr-2"
                  small dark color="green"
                  @click="exportExcel( prospectos  , 'PROSPECTOS')"
                  tile
                >
                  <v-icon small>mdi-microsoft-excel</v-icon>
                </v-btn>
              </v-col>
            </v-row>

            <!--Lista de prospectos-->
            <v-data-table
              v-if="![1258].includes( getdatosUsuarioERPERP.iderp )"
              :headers="headers"
              :items="prospectos"
              class="elevation-0"
              :search="search"
              dense
            >

              <template v-slot:item.folio="{ item }">
                <v-icon small color="orange" v-if="item.reasignado">mdi-circle</v-icon>{{ item.folio }}
              </template>

              <template v-slot:item.name="{ item }">
                <div @click="(prospecto = item), (dialogUsuario = true)" type="button">{{ item.name }}</div>
              </template>

              <template v-slot:item.ver="{ item }">
                <v-icon small class="mr-2" @click="(prospecto = item), (dialogUsuario = true)" color="primary"> mdi-pencil </v-icon>
              </template>

              <template v-slot:item.estatus="{ item }">
                <v-chip small dense v-if="item.idetapa == 2" color="green" dark>Nuevo</v-chip>
                <v-chip small dense v-if="item.idetapa == 1" color="red" dark>Atrasado</v-chip>
              </template>


              <template v-slot:item.match="{ item }">
                <v-chip small dense v-if="item.match" color="green" dark></v-chip>
                <v-chip small dense v-else color="red" dark></v-chip>
              </template>


              <template v-slot:item.ReferralSourceUrl="{ item }">
                <span small @click="previewLink( item )">{{ item.ReferralSourceUrl }}</span>
              </template>

              <template v-slot:item.tipo_match="{ item }">
                <span small class="orange--text" v-if="item.tipo_match == 3">Campaña</span>
                <span small class="red--text" v-else-if="item.tipo_match == 1">Mensaje</span>
                <span small class="green--text" v-else>Selección</span>
              </template>

            </v-data-table>

          </v-card-text>
        </v-card>

      </v-col>
    </v-row>

    <v-dialog
      v-model="dialogPreview"
      max-width="600px"
    >
      <v-card>
        <v-card-title class="text-subtitle-1">
          Previsualizar publicación
        </v-card-title>
        <v-card-text v-if="dataPreview">

          Link: {{ dataPreview.ReferralSourceUrl }}

          <br/>
          <br/>

          <iframe :src="dataPreview.ReferralSourceUrl" width="500" height="600"></iframe>

        </v-card-text>
        <v-card-actions>

          <v-btn block color="primary" @click="verEnWEB( dataPreview )"> Ver en web </v-btn>
        <v-btn
          tile
          top
          absolute
          icon
          right
          @click="dialogPreview = false"
        >
          <v-icon small left>mdi-close</v-icon>
        </v-btn>
        <v-spacer></v-spacer>
      </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialogUsuario"
      max-width="500px"
      >

      <!-- Lista de vendedoras -->

      <v-card>
        <v-card-title>
          <span class="text-subtitle-1">Asignación de contactos</span>
        </v-card-title>

        <v-card-text>
          <v-autocomplete
            :items="filterVendedoras"
            v-model="usuario"
            label="Selecciona vendedora"
            item-value="iderp"
            item-text="nombre_plantel"
            filled
            dense
            hide-details
          ></v-autocomplete>
        </v-card-text>

        <v-card-actions>
          <v-btn
            color="black"
            dark
            small
            tile
            @click="close"
          >
            <v-icon small left>mdi-cancel</v-icon>
            Cancelar
          </v-btn>
          <v-spacer></v-spacer>

          <v-btn
            color="green"
            dark
            small
            tile
            @click="actualizar()"
          >
            Guardar
            <v-icon small right>mdi-content-save</v-icon>
          </v-btn>

        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialogMensajes"
      max-width="1400px"
    >
      <v-card>
        <v-card-title class="text-subtitle-1">
          Datos de los contactos
          <v-spacer></v-spacer>
          <v-btn
            class="mr-10"
            small dark color="green"
            @click="exportExcel( tablaContactos  , 'MENSAJES')"
            tile
          >
            <v-icon small>mdi-microsoft-excel</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="black--text">
          <v-row>
            <v-col cols="12">
              <v-radio-group
                v-model="opZona"
                row
              >
                <v-radio
                  v-for="(base, i) in baseEscuela"
                  :key="i"
                  :label="base.zona"
                  :value="base.zona"
                ></v-radio>
              </v-radio-group>
            </v-col>

            <v-col cols="12" lg="6">
              <div
                v-for="(base, i) in baseEscuela"
                :key="i"
                v-if="base.zona != 'TODOS'"
              >
                <b>{{ base.zona }} :</b> {{ tablaContactos ? tablaContactos.filter( el => el.sistema == base.zona ).length : 0 }}
              </div>
              <div
                v-for="(base, i) in baseEscuela"
                :key="i"
                v-if="base.zona == 'TODOS'"
              >
                <b>{{ base.zona }} :</b> {{ tablaContactos.length }}
              </div>
            </v-col>

            <v-col cols="12" lg="6">
              <b>Twilio Completo: </b> {{ totalTwilioCompleto }}<br/>
              <b>Twilio Incompleto: </b> {{ totalTwilioIncompleto }}<br/>
              <b>Mercadotecnía: </b> {{ totalMerca }}<br/>
              <b>Sucursal: </b> {{ totalSucursal }}<br/>
              <b>General: </b> {{ totalGeneral }}<br/>
            </v-col>


          </v-row>
          <v-data-table
            :headers="headers3"
            :items="filterTablaContactos"
            class="elevation-0"
            dense
            mobile-breakpoint="200"
          >
          </v-data-table>
        </v-card-text>
        <v-card-actions>
        <v-btn
          tile
          top
          absolute
          icon
          right
          @click="dialogMensajes = false"
        >
          <v-icon small left>mdi-close</v-icon>
        </v-btn>
        <v-spacer></v-spacer>
      </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Mostrar todos los alumnos inscritos -->
    <v-dialog
      v-model="dialogAlumnos"
      max-width="1400px"
    >
      <v-card>
        <v-card-title class="text-subtitle-1">
          Datos de los alumnos inscritos
          <v-spacer></v-spacer>
          <v-btn
            class="mr-10"
            small dark color="green"
            @click="exportExcel( tablaAlumnos  , 'MENSAJES')"
            tile
          >
            <v-icon small>mdi-microsoft-excel</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-data-table
            :headers="headersAlumnos"
            :items="tablaAlumnos"
            class="elevation-0"
            dense
            mobile-breakpoint="200"
          >
          </v-data-table>
        </v-card-text>
        <v-card-actions>
        <v-btn
          tile
          top
          absolute
          icon
          right
          @click="dialogAlumnos = false"
        >
          <v-icon small left>mdi-close</v-icon>
        </v-btn>
        <v-spacer></v-spacer>
      </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Agregar LEAD -->
    <v-dialog
      v-model="dialog"
      max-width="500px"
    >
      <nuevo_lead
        :formTitle="formTitle"
        :editedItem="editedItem"
        :cursos_escuela="cursos_escuela"
        :vendedoras_plantel="filterVendedoras"
        :fuentes="fuentes"
        :detallesFilter="detallesFilter"
        :medios_contacto="medios_contacto"
        :campaniasFilter="campaniasFilter"
        :escuela="escuela"
        @save="save"
        @close="close"
        @buscarTelefono="buscarTelefono"
        :contadorVendedoras="contadorVendedoras2"
      />
    </v-dialog>


    <AsignacionTwilio
      v-if="dialogTwilio.estatus"
      :dialogTwilio="dialogTwilio"
      :escuela="escuela"
    />


    <SeguimientoVendedora
      v-if="dialogVendedora.estatus"
      :dialogVendedora="dialogVendedora"
      :contadorVendedoras="contadorVendedoras2"
      :escuela="escuela"
    />

    <DiferenciasVendedora
      v-if="dialogDiferencias.estatus"
      :dialogDiferencias="dialogDiferencias"
      :contadorVendedoras="contadorVendedoras2"
      :escuela="escuela"
    />

    <ReporteEfectividad
      v-if="dialogEfectividad.estatus"
      :dialogEfectividad="dialogEfectividad"
      :contadorVendedoras="contadorVendedoras2"
      :escuela="escuela"
    />

    <SucursalInteres
      v-if="dialogReporteSucursal.estatus"
      :dialogReporteSucursal="dialogReporteSucursal"
      :contadorVendedoras="contadorVendedoras2"
      :escuela="escuela"
    />

    <BuenSeguimiento
      v-if="dialogBuenSeguimiento.estatus"
      :dialogBuenSeguimiento="dialogBuenSeguimiento"
      :contadorVendedoras="contadorVendedoras2"
      :escuela="escuela"
    />

    <Campanias
      v-if="dialogReporte.estatus"
      :dialogReporte="dialogReporte"
      :escuela="escuela"
    />

    <CampaniasGoogle
      v-if="dialogReporteGoogle.estatus"
      :dialogReporteGoogle="dialogReporteGoogle"
      :escuela="escuela"

    />

    <ReasignarVendedora
      v-if="dialogResaginar.estatus"
      :dialogResaginar="dialogResaginar"
    />

    <DialogEtiquetas
      :prospectos="prospectos"
      :dialogEtiquetas="dialogEtiquetas"
      @closeDialogEtiquetas="closeDialogEtiquetas"
    />

    <!-- Dialog de carga -->
    <Alerta               v-if="respuestaAlerta"             :parametros="parametros"/>
    <carga                v-if="cargar"/>

  </v-container>
</template>


<script>
  import axios from 'axios';
  import { mapGetters } from 'vuex'
  // Componentes
  import Alerta                from '@/components/alertas/Alerta.vue'
  import carga                 from '@/components/alertas/carga.vue';

  import validarErrores        from '@/mixins/validarErrores'
  import funcionesExcel        from '@/mixins/funcionesExcel'
  import mixinLeads            from '@/mixins/mixinLeads'
  import nuevo_lead            from '@/components/leads/nuevo_lead.vue';
  import basicosTablas         from '@/mixins/basicosTablas'
  import AsignacionTwilio      from '@/components/whatsapp/AsignacionTwilio'
  import SeguimientoVendedora  from '@/components/leads/SeguimientoVendedora'
  import DiferenciasVendedora  from '@/components/leads/DiferenciasVendedora'
  import ReasignarVendedora    from '@/components/leads/ReasignarVendedora'
  import ReporteEfectividad    from '@/components/leads/ReporteEfectividad'
  import SucursalInteres       from '@/components/leads/SucursalInteres'
  import BuenSeguimiento       from '@/components/leads/BuenSeguimiento'
  import Campanias             from '@/components/leads/Campanias'
  import CampaniasGoogle       from '@/components/leads/CampaniasGoogle'
  import DialogEtiquetas       from '@/components/prospectos/DialogEtiquetas'

  export default {
    components:{
      Alerta,
      carga,
      nuevo_lead,
      AsignacionTwilio,
      SeguimientoVendedora,
      DiferenciasVendedora,
      ReasignarVendedora,
      ReporteEfectividad,
      SucursalInteres,
      BuenSeguimiento,
      Campanias,
      CampaniasGoogle,
      DialogEtiquetas
    },

    mixins: [ validarErrores, funcionesExcel, mixinLeads, basicosTablas ],

    //Data
    data: () => ({
      dialogEtiquetas: false,
      filasTotales: [],
      // Alertas
      parametros:{
        dialogError: false,
        mensaje: '',
        color: ''
      },

      respuestaAlerta:false,
      loader: true,
      cargar: false,

      //datos que se desplegaran en las 2 tablas
      prospectos: [],
      usuarios: [],
      usuario: null,
      dialogUsuario: false,

      ciudades: [
        "Sin estado",
        "Monterrey",
        "CDMX",
        "GDL",
        "FAST",
      ],
      headers: [
        { text: "Folio"      , value: "folio" },
        { text: "Plantel"    , value: "plantel" },
        { text: "Telefono"   , value: "telefono" },
        { text: "Nombre"     , value: "nombre_completo" },
        { text: "Vendedora"  , value: "name" },
        { text: "Matricula"  , value: "matricula" },
        { text: "Estatus"    , value: "estatus" },
        { text: "Completo"   , value: "completo" },
        { text: "Match"      , value: "match" },
        { text: "Fecha"      , value: "fecha_creacion" },
        { text: "Campaña"    , value: "ReferralSourceId" },
        { text: "Preview"    , value: "ReferralSourceUrl" },
        { text: "Encabezado" , value: "ReferralHeadline" },
        { text: "Tipo Match" , value: "tipo_match" },
      ],

      fechaini: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      fechafin: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),

      checkGeneral: 1,
      checkCompletos: 1,
      checkIncompletos: 1,
      checkMerca: 1,
      checkSucursal: 1,

      search: "",

      escuela: 1,

      vendedoras: [],

      vendedorasAll:[],

      headersAll:[],
      search2:'',
      contactosActivos:[],

      contactosVsFecha:[],
      contactosInscritos:[],

      cursos_escuela:[],
      medios_contacto:[],

      searchTelefono:'',

      headers3:[
        { text: "Folio"         , value: "folio"            },
        { text: "Nombre"        , value: "nombre_completo"  },
        { text: "Creó"          , value: "creo"             },
        { text: "Plantel"       , value: "plantel"          },
        { text: "Usuario"       , value: "twilio"           },
        { text: "Sistema"       , value: "sistema"          },
        { text: "Mensaje"       , value: "mensaje"          },
        { text: "Fecha"         , value: "fecha_creacion"   },
        { text: "Vendedora"     , value: "name"             },
        { text: "Clasificación" , value: "clasificacion"    },
      ],


      headersAlumnos:[
        { text: "alumno"        , value: "id_alumno"        },
        { text: "Nombre"        , value: "nombre_completo"  },
        { text: "Grupo"         , value: "grupo"            },
        { text: "Folio"         , value: "folio"            },
        { text: "F. Fecha"      , value: "folio_fecha"      },
        { text: "Pagó"          , value: "fecha_pago"       },
        { text: "Clasif"        , value: "clasificacion"    },
      ],

      editedItem: {
        nombre_completo:'',
        idleds:'',
        escuela: 1,
        iddetalle_fuentes:0,
        idfuentes: 0,
        fuente: '',
        estatus: '',
        foraneo: 0,
        idcursos_escuela: 0,
        telefono:'',
        sucursal:0,
        nota_inicial:'El prospecto desea información',
        idmedio_contacto:0,
        idcampanias:0,
        id_sucursal_interes:0,
        curso_interes: 0,
        horario_interes:'',
        respondio: 0,
      },

      sucursales:[],
      sucursal:null,

      vendedoras_plantel:[],
      vendedora:null,
      campanias:[],
      campania:null,
      fuentes:[],

      tablaContactos: [],
      dialogMensajes: false,

      dialogTwilio: {
        estatus: false
      },

      dialogVendedora: {
        estatus: false
      },

      dialogDiferencias: {
        estatus: false
      },

      dialogResaginar:{
        estatus: false
      },

      dialogEfectividad:{
        estatus: false
      },

      dialog: false,

      dialogReporteSucursal:{
        estatus: false
      },

      dialogBuenSeguimiento:{
        estatus: false
      },

      dialogReporteGoogle:{
        estatus: false
      },

      dialogReporte:{
        estatus: false
      },

      baseEscuela:[],
      opZona: 'TODOS',

      tablaAlumnos:[],
      dialogAlumnos: false,
      totalMatriculas:[],

      dialogPreview: false,
      dataPreview: null,

    }),

    //Computed
    computed: {

      ...mapGetters('login',['getdatosUsuarioERPERP']),

      totalGeneral( ){

        return this.tablaContactos.length

      },

      totalSucursal( ){

        return this.tablaContactos && this.tablaContactos.length ? this.tablaContactos.filter( el => el.clasificacion == 'SUCURSAL' ).length : 0

      },

      totalMerca( ){

        return this.tablaContactos && this.tablaContactos.length ? this.tablaContactos.filter( el => el.clasificacion == 'MERCADOTECNIA' ).length : 0

      },

      totalTwilioCompleto( ){

        return this.tablaContactos && this.tablaContactos.length ? this.tablaContactos.filter( el => el.clasificacion == 'TWILIO COMPLETO' ).length : 0

      },

      totalTwilioIncompleto( ){

        return this.tablaContactos && this.tablaContactos.length ? this.tablaContactos.filter( el => el.clasificacion == 'TWILIO INCOMPLETO' ).length : 0

      },


      dialog (val) {
        val || this.close()
      },

      formTitle () {
        return this.editedIndex === -1 ? 'Agregar un LEAD' : 'Editar LEAD'
      },

      filterVendedoras( ){

        return this.vendedoras.filter( el => el.escuela == this.escuela )

      },

      filterVendedoras2( ){

        return this.vendedorasAll.filter( el => el.escuela == this.escuela )

      },

      detallesFilter(){
        return this.detalles ? this.detalles.filter(el => { return el.idfuentes == this.editedItem.idfuentes }) : []
      },

      campaniasFilter(){
        return this.campanias ? this.campanias.filter(el => { return el.idmedio_contacto == this.editedItem.idmedio_contacto }) : []
      },

      contadorVendedoras( ){

        // iniciar clasificación
        for( const i in this.prospectos ){

          const { nombre_completo, idpuesto, estado } = this.prospectos[i]

          if( nombre_completo.match('TWILIO COMPLETO') ){

            this.prospectos[i]['clasificacion'] = 'TWILIO COMPLETO'

          }else if( nombre_completo.match('TWILIO INCOMPLETO') ){

            this.prospectos[i]['clasificacion'] = 'TWILIO INCOMPLETO'

          }else if( !nombre_completo.match('TWILIO') && [25,48,49,54,62,74,97,101].includes( idpuesto ) ){

            this.prospectos[i]['clasificacion'] = 'MERCADOTECNIA'

          }else{

            this.prospectos[i]['clasificacion'] = 'SUCURSAL'

          }


        }

        let data = []

        for( const i in this.filterVendedoras2 ){

          const { nombre, iderp, estado } = this.filterVendedoras2[i]

          data.push({
            vendedora       : nombre,
            estado          : estado,
            contactos       : this.prospectos.filter( el => el.usuario_asignado == iderp).length,
            contactosall    : this.prospectos.filter( el => el.usuario_asignado == iderp),
            contactosGeneral: this.prospectos.filter( el => el.usuario_asignado == iderp),
            iderp
          })

        }

        // Sacamos los últimos datos
        let uniqueArray = data.filter((obj, index, self) =>
          index === self.findIndex((el) => el.iderp === obj.iderp)
        );

        console.log( 'uniqueArray', uniqueArray )

        uniqueArray = uniqueArray.sort((a, b) => b.contactos - a.contactos);

        // Carga laboral
        for( const i in uniqueArray ){

          const { iderp, contactosall, vendedora } = uniqueArray[i]

          const existenContactos = this.contactosActivos.find( el => el.usuario_asignado == iderp )

          let contactos = existenContactos ? existenContactos.contactos : 0

          let sumaTotal = this.contactosActivos.map(item => item.contactos).reduce((prev, curr) => prev + curr, 0)

          let carga = (( contactos / sumaTotal ) * 100 ).toFixed( 2 )

          uniqueArray[i]['carga'] = carga

          let completos   = contactosall.filter( el => el.nombre_completo.match('TWILIO COMPLETO')).length
          let incompletos = contactosall.filter( el => el.nombre_completo.match('TWILIO INCOMPLETO')).length
          let merca       = contactosall.filter( el => !el.nombre_completo.match('TWILIO') && [25,48,49,54,62,74,97,101].includes( el.idpuesto ) ).length
          let total       = completos + incompletos + merca

          uniqueArray[i]['contactosall']  = contactos
          uniqueArray[i]['completos']     = contactosall.filter( el => el.nombre_completo.match('TWILIO COMPLETO'))
          uniqueArray[i]['incompletos']   = contactosall.filter( el => el.nombre_completo.match('TWILIO INCOMPLETO'))
          uniqueArray[i]['merca']         = contactosall.filter( el => !el.nombre_completo.match('TWILIO') && [25,48,49,54,62,74,97,101].includes( el.idpuesto ) )
          uniqueArray[i]['sucursal']      = contactosall.filter( el => !el.nombre_completo.match('TWILIO') && ![25,48,49,54,62,74,97,101].includes( el.idpuesto ) )

          uniqueArray[i]['completosNumero']     = contactosall.filter( el => el.nombre_completo.match('TWILIO COMPLETO')).length
          uniqueArray[i]['incompletosNumero']   = contactosall.filter( el => el.nombre_completo.match('TWILIO INCOMPLETO')).length
          uniqueArray[i]['mercaNumero']         = contactosall.filter( el => !el.nombre_completo.match('TWILIO') && [25,48,49,54,62,74,97,101].includes( el.idpuesto ) ).length
          uniqueArray[i]['sucursalNumero']      = contactosall.filter( el => !el.nombre_completo.match('TWILIO') && ![25,48,49,54,62,74,97,101].includes( el.idpuesto ) ).length


          uniqueArray[i]['porcentajemkt'] = (( completos / total ) * 100 ).toFixed( 2 )

        }

        let alumnosCompletosAll = []
        let alumnosIncompletosAll = []
        let alumnosMercaAll = []
        let alumnosSucursalAll = []
        let alumnosTotalAll = []

        // Convencimiento
        for( const i in uniqueArray ){

          let { iderp, completos, incompletos, merca, sucursal, vendedora } = uniqueArray[i]

          for( const i in completos ){

            const { mialumnos, folio, fecha_completa } = completos[i]

            for( const j in mialumnos ){

              mialumnos[j]['folio'] = folio
              mialumnos[j]['folio_fecha'] = fecha_completa

            }
          }

          for( const i in incompletos ){

            const { mialumnos, folio, fecha_completa } = incompletos[i]

            for( const j in mialumnos ){

              mialumnos[j]['folio'] = folio
              mialumnos[j]['folio_fecha'] = fecha_completa

            }
          }

          for( const i in merca ){

            const { mialumnos, folio, fecha_completa } = merca[i]

            for( const j in mialumnos ){

              mialumnos[j]['folio'] = folio
              mialumnos[j]['folio_fecha'] = fecha_completa

            }
          }

          for( const i in sucursal ){

            const { mialumnos, folio, fecha_completa } = sucursal[i]

            for( const j in mialumnos ){

              mialumnos[j]['folio'] = folio
              mialumnos[j]['folio_fecha'] = fecha_completa

            }
          }


          const existenContactos = this.contactosVsFecha.filter( el => el.usuario_asignado == iderp )

          let contactos = this.contactosVsFecha.filter( el => el.usuario_asignado == iderp ).length

          let alumnosCompletos   = completos.filter( el => el.mialumno ).map(( registro ) => { return registro.mialumnos })
          let alumnosIncompletos = incompletos.filter( el => el.mialumno ).map(( registro ) => { return registro.mialumnos })
          let alumnosMerca       = merca.filter( el => el.mialumno ).map(( registro ) => { return registro.mialumnos })
          let alumnosSucursal    = sucursal.filter( el => el.mialumno ).map(( registro ) => { return registro.mialumnos })



          let inscritosAlumnos     = [ ...alumnosCompletos, ...alumnosIncompletos, ...alumnosMerca, ...alumnosSucursal ].flat()


          let inscritosCompletos   = alumnosCompletos.flat().length
          let inscritosIncompletos = alumnosIncompletos.flat().length
          let inscritosMerca       = alumnosMerca.flat().length
          let inscritosSucursal    = alumnosSucursal.flat().length



          let convencimientoCompletos   = (( inscritosCompletos   / completos.length   ) * 100 ).toFixed( 2 )
          let convencimientoIncompletos = (( inscritosIncompletos / incompletos.length ) * 100 ).toFixed( 2 )
          let convencimientoMerca       = (( inscritosMerca       / merca.length       ) * 100 ).toFixed( 2 )
          let convencimientoSucursal    = (( inscritosSucursal    / sucursal.length    ) * 100 ).toFixed( 2 )

          uniqueArray[i]['inscritosCompletos']     = alumnosCompletos.flat()
          uniqueArray[i]['inscritosIncompletos']   = alumnosIncompletos.flat()
          uniqueArray[i]['inscritosMerca']         = alumnosMerca.flat()
          uniqueArray[i]['inscritosSucursal']      = alumnosSucursal.flat()

          alumnosCompletosAll = alumnosCompletosAll.concat( alumnosCompletos.flat() )
          alumnosIncompletosAll = alumnosIncompletosAll.concat( alumnosIncompletos.flat() )
          alumnosMercaAll = alumnosMercaAll.concat( alumnosMerca.flat() )
          alumnosSucursalAll = alumnosSucursalAll.concat( alumnosSucursal.flat() )
          alumnosTotalAll = alumnosTotalAll.concat( alumnosCompletos.flat() ).concat( alumnosIncompletos.flat() ).concat( alumnosMerca.flat() ).concat( alumnosSucursal.flat() )

          for( const j in uniqueArray[i]['inscritosCompletos'] ){
            uniqueArray[i]['inscritosCompletos'][j]['clasificacion'] = 'TWILIO COMPLETO'
          }

          for( const j in uniqueArray[i]['inscritosIncompletos'] ){
            uniqueArray[i]['inscritosIncompletos'][j]['clasificacion'] = 'TWILIO INCOMPLETO'
          }

          for( const j in uniqueArray[i]['inscritosMerca'] ){
            uniqueArray[i]['inscritosMerca'][j]['clasificacion'] = 'MERCADOTECNIA'
          }

          for( const j in uniqueArray[i]['inscritosSucursal'] ){
            uniqueArray[i]['inscritosSucursal'][j]['clasificacion'] = 'SUCURSAL'
          }

          let inscritos = alumnosCompletos.flat().length + alumnosIncompletos.flat().length + alumnosMerca.flat().length + alumnosSucursal.flat().length

          uniqueArray[i]['convencimientoCompletos']     = convencimientoCompletos + '%'
          uniqueArray[i]['convencimientoIncompletos']   = convencimientoIncompletos + '%'
          uniqueArray[i]['convencimientoMerca']         = convencimientoMerca + '%'
          uniqueArray[i]['convencimientoSucursal']      = convencimientoSucursal + '%'

          let convencimiento = contactos > 0 ? (( inscritos / contactos ) * 100 ).toFixed( 2 ) : 0

          uniqueArray[i]['convencimiento']    = convencimiento + '%'
          uniqueArray[i]['desglose']          = `( Inscritos( ${inscritos} ) / Contactos( ${contactos} ) ) * 100 `
          uniqueArray[i]['inscritos']         = inscritos
          uniqueArray[i]['inscritos_detalle'] = inscritosAlumnos // this.contactosInscritos.filter( el => el.id_usuario_ultimo_cambio == iderp )
          uniqueArray[i]['inscritos_fecha']   = this.filterVendedoras2.filter( el => el.id_usuario_ultimo_cambio == iderp )

          // Primero, agregarmos las ventas del KPI al momento
          uniqueArray[i]['ventas_momento'] = this.totalMatriculas.filter( el => el.id_usuario_ultimo_cambio == iderp ).length
          uniqueArray[i]['porcentajeCompletos'] = (( completos.length / contactos ) * 100 ).toFixed( 2 )

          if( iderp == 2785 ){
            console.log( '2785', vendedora )
            console.log( uniqueArray[i]['ventas_momento']  )
            console.log( this.totalMatriculas.filter( el => el.id_usuario_ultimo_cambio == iderp ) )
          }

        }

        // Buscar la vendedora que mejor se acomode
        // Ordenar por % de convencimiento (desc) y luego por carga laboral (asc)
        uniqueArray.sort((a, b) =>
          b.convencimiento - a.convencimiento || parseFloat(a.contactos) - parseFloat(b.contactos)
        );

        // Agregar ranking y determinar si pueden recibir más contactos
        uniqueArray.forEach((vendedora, index) => {
          vendedora.puedeRecibir = (vendedora.contactos ) <= 5;
        });

        let contador3 = 0
        uniqueArray.forEach((vendedora, index) => {
          vendedora.ranking = vendedora.puedeRecibir ? contador3 + 1 : 0  ;
          contador3 += vendedora.puedeRecibir ? 1 : 0
        });

        let contador = uniqueArray.filter( el => el.ranking ).length
        uniqueArray.forEach((vendedora, index) => {
          vendedora.ranking = vendedora.ranking ? vendedora.ranking : contador + 1  ;
          contador += vendedora.ranking ? 1 : 0
        });


        // Ordenamos por ventas en kpi
        uniqueArray.sort((a, b) => b.ventas_momento - a.ventas_momento);
        for( const i in uniqueArray ){

          uniqueArray[i]['position_ventas_momento'] = parseInt( i ) + 1

        }


        // Ahora ordenamos por contactos
        uniqueArray.sort((a, b) => b.contactos - a.contactos);

        for( const i in uniqueArray ){

          uniqueArray[i]['position'] = parseInt( i ) + 1

        }


        for( const i in uniqueArray ){

          const { contactosGeneral, position_ventas_momento, position } = uniqueArray[i]


          uniqueArray[i]['TWILIO CDMX'] = contactosGeneral.filter( el => el.sistema == 'TWILIO CDMX' ).length

          uniqueArray[i]['TWILIO GUADALAJARA'] = contactosGeneral.filter( el => el.sistema == 'TWILIO GUADALAJARA' ).length

          uniqueArray[i]['TWILIO MONTERREY'] = contactosGeneral.filter( el => el.sistema == 'TWILIO MONTERREY' ).length

          uniqueArray[i]['TWILIO CRM INBI'] = contactosGeneral.filter( el => el.sistema == 'TWILIO CRM INBI' ).length

          uniqueArray[i]['SUCURSAL EXTERNO'] = contactosGeneral.filter( el => !el.sistema  ).length

          uniqueArray[i]['TODOS'] = contactosGeneral.length

          uniqueArray[i]['diferencia'] = position - position_ventas_momento
        }

        // Solo sumatoria: TOTAL = suma de filas por ciudad × vendedora / ciudad × contacto
        this.filasTotales = this.escuela === 2
          ? [
              this.buildFilaTotalPorCiudad('FAST', uniqueArray),
              this.buildFilaTotalPorCiudad('TODAS', uniqueArray),
            ]
          : [
              this.buildFilaTotalPorCiudad('Monterrey', uniqueArray),
              this.buildFilaTotalPorCiudad('CDMX', uniqueArray),
              this.buildFilaTotalPorCiudad('GDL', uniqueArray),
              this.buildFilaTotalPorCiudad('TODAS', uniqueArray),
            ]

        this.validarSumatoriaTotales(uniqueArray, this.filasTotales)

        // Totales de ciudad/TODAS (universo completo). Los de baja se reasignan al cargar; ya no hay fila TOTAL Baja.
        this.filasTotales.forEach((it) => {
          if (it.estado == 'TODAS') {
            it.contactos = this.prospectos.length
            it.contactosall = this.prospectos
          }
        })

        return uniqueArray

      },

      contadorVendedoras2( ){

        // iniciar clasificación
        for( const i in this.prospectos ){

          const { nombre_completo, idpuesto, estado } = this.prospectos[i]

          if( nombre_completo.match('TWILIO COMPLETO') ){

            this.prospectos[i]['clasificacion'] = 'TWILIO COMPLETO'

          }else if( nombre_completo.match('TWILIO INCOMPLETO') ){

            this.prospectos[i]['clasificacion'] = 'TWILIO INCOMPLETO'

          }else if( !nombre_completo.match('TWILIO') && [25,48,49,54,62,74,97,101].includes( idpuesto ) ){

            this.prospectos[i]['clasificacion'] = 'MERCADOTECNIA'

          }else{

            this.prospectos[i]['clasificacion'] = 'SUCURSAL'

          }


        }

        let data = []

        for( const i in this.filterVendedoras ){

          const { nombre, iderp, estado } = this.filterVendedoras[i]

          data.push({
            vendedora       : nombre,
            estado          : estado,
            contactos       : this.prospectos.filter( el => el.usuario_asignado == iderp).length,
            contactosall    : this.prospectos.filter( el => el.usuario_asignado == iderp),
            contactosGeneral: this.prospectos.filter( el => el.usuario_asignado == iderp),
            iderp
          })

        }

        // Sacamos los últimos datos
        let uniqueArray = data.filter((obj, index, self) =>
          index === self.findIndex((el) => el.iderp === obj.iderp)
        );

        uniqueArray = uniqueArray.sort((a, b) => b.contactos - a.contactos);

        // Carga laboral
        for( const i in uniqueArray ){

          const { iderp, contactosall, vendedora } = uniqueArray[i]

          const existenContactos = this.contactosActivos.find( el => el.usuario_asignado == iderp )

          let contactos = existenContactos ? existenContactos.contactos : 0

          let sumaTotal = this.contactosActivos.map(item => item.contactos).reduce((prev, curr) => prev + curr, 0)

          let carga = (( contactos / sumaTotal ) * 100 ).toFixed( 2 )

          uniqueArray[i]['carga'] = carga

          let completos   = contactosall.filter( el => el.nombre_completo.match('TWILIO COMPLETO')).length
          let incompletos = contactosall.filter( el => el.nombre_completo.match('TWILIO INCOMPLETO')).length
          let merca       = contactosall.filter( el => !el.nombre_completo.match('TWILIO') && [25,48,49,54,62,74,97,101].includes( el.idpuesto ) ).length
          let total       = completos + incompletos + merca

          uniqueArray[i]['contactosall']  = contactos
          uniqueArray[i]['completos']     = contactosall.filter( el => el.nombre_completo.match('TWILIO COMPLETO'))
          uniqueArray[i]['incompletos']   = contactosall.filter( el => el.nombre_completo.match('TWILIO INCOMPLETO'))
          uniqueArray[i]['merca']         = contactosall.filter( el => !el.nombre_completo.match('TWILIO') && [25,48,49,54,62,74,97,101].includes( el.idpuesto ) )
          uniqueArray[i]['sucursal']      = contactosall.filter( el => !el.nombre_completo.match('TWILIO') && ![25,48,49,54,62,74,97,101].includes( el.idpuesto ) )

          uniqueArray[i]['completosNumero']     = contactosall.filter( el => el.nombre_completo.match('TWILIO COMPLETO')).length
          uniqueArray[i]['incompletosNumero']   = contactosall.filter( el => el.nombre_completo.match('TWILIO INCOMPLETO')).length
          uniqueArray[i]['mercaNumero']         = contactosall.filter( el => !el.nombre_completo.match('TWILIO') && [25,48,49,54,62,74,97,101].includes( el.idpuesto ) ).length
          uniqueArray[i]['sucursalNumero']      = contactosall.filter( el => !el.nombre_completo.match('TWILIO') && ![25,48,49,54,62,74,97,101].includes( el.idpuesto ) ).length


          uniqueArray[i]['porcentajemkt'] = (( completos / total ) * 100 ).toFixed( 2 )

        }

        let alumnosCompletosAll = []
        let alumnosIncompletosAll = []
        let alumnosMercaAll = []
        let alumnosSucursalAll = []
        let alumnosTotalAll = []

        // Convencimiento
        for( const i in uniqueArray ){

          let { iderp, completos, incompletos, merca, sucursal, vendedora } = uniqueArray[i]

          for( const i in completos ){

            const { mialumnos, folio, fecha_completa } = completos[i]

            for( const j in mialumnos ){

              mialumnos[j]['folio'] = folio
              mialumnos[j]['folio_fecha'] = fecha_completa

            }
          }

          for( const i in incompletos ){

            const { mialumnos, folio, fecha_completa } = incompletos[i]

            for( const j in mialumnos ){

              mialumnos[j]['folio'] = folio
              mialumnos[j]['folio_fecha'] = fecha_completa

            }
          }

          for( const i in merca ){

            const { mialumnos, folio, fecha_completa } = merca[i]

            for( const j in mialumnos ){

              mialumnos[j]['folio'] = folio
              mialumnos[j]['folio_fecha'] = fecha_completa

            }
          }

          for( const i in sucursal ){

            const { mialumnos, folio, fecha_completa } = sucursal[i]

            for( const j in mialumnos ){

              mialumnos[j]['folio'] = folio
              mialumnos[j]['folio_fecha'] = fecha_completa

            }
          }


          const existenContactos = this.contactosVsFecha.filter( el => el.usuario_asignado == iderp )

          let contactos = this.contactosVsFecha.filter( el => el.usuario_asignado == iderp ).length

          let alumnosCompletos   = completos.filter( el => el.mialumno ).map(( registro ) => { return registro.mialumnos })
          let alumnosIncompletos = incompletos.filter( el => el.mialumno ).map(( registro ) => { return registro.mialumnos })
          let alumnosMerca       = merca.filter( el => el.mialumno ).map(( registro ) => { return registro.mialumnos })
          let alumnosSucursal    = sucursal.filter( el => el.mialumno ).map(( registro ) => { return registro.mialumnos })



          let inscritosAlumnos     = [ ...alumnosCompletos, ...alumnosIncompletos, ...alumnosMerca, ...alumnosSucursal ].flat()


          let inscritosCompletos   = alumnosCompletos.flat().length
          let inscritosIncompletos = alumnosIncompletos.flat().length
          let inscritosMerca       = alumnosMerca.flat().length
          let inscritosSucursal    = alumnosSucursal.flat().length



          let convencimientoCompletos   = (( inscritosCompletos   / completos.length   ) * 100 ).toFixed( 2 )
          let convencimientoIncompletos = (( inscritosIncompletos / incompletos.length ) * 100 ).toFixed( 2 )
          let convencimientoMerca       = (( inscritosMerca       / merca.length       ) * 100 ).toFixed( 2 )
          let convencimientoSucursal    = (( inscritosSucursal    / sucursal.length    ) * 100 ).toFixed( 2 )

          uniqueArray[i]['inscritosCompletos']     = alumnosCompletos.flat()
          uniqueArray[i]['inscritosIncompletos']   = alumnosIncompletos.flat()
          uniqueArray[i]['inscritosMerca']         = alumnosMerca.flat()
          uniqueArray[i]['inscritosSucursal']      = alumnosSucursal.flat()

          alumnosCompletosAll = alumnosCompletosAll.concat( alumnosCompletos.flat() )
          alumnosIncompletosAll = alumnosIncompletosAll.concat( alumnosIncompletos.flat() )
          alumnosMercaAll = alumnosMercaAll.concat( alumnosMerca.flat() )
          alumnosSucursalAll = alumnosSucursalAll.concat( alumnosSucursal.flat() )
          alumnosTotalAll = alumnosTotalAll.concat( alumnosCompletos.flat() ).concat( alumnosIncompletos.flat() ).concat( alumnosMerca.flat() ).concat( alumnosSucursal.flat() )

          for( const j in uniqueArray[i]['inscritosCompletos'] ){
            uniqueArray[i]['inscritosCompletos'][j]['clasificacion'] = 'TWILIO COMPLETO'
          }

          for( const j in uniqueArray[i]['inscritosIncompletos'] ){
            uniqueArray[i]['inscritosIncompletos'][j]['clasificacion'] = 'TWILIO INCOMPLETO'
          }

          for( const j in uniqueArray[i]['inscritosMerca'] ){
            uniqueArray[i]['inscritosMerca'][j]['clasificacion'] = 'MERCADOTECNIA'
          }

          for( const j in uniqueArray[i]['inscritosSucursal'] ){
            uniqueArray[i]['inscritosSucursal'][j]['clasificacion'] = 'SUCURSAL'
          }

          let inscritos = alumnosCompletos.flat().length + alumnosIncompletos.flat().length + alumnosMerca.flat().length + alumnosSucursal.flat().length

          uniqueArray[i]['convencimientoCompletos']     = convencimientoCompletos + '%'
          uniqueArray[i]['convencimientoIncompletos']   = convencimientoIncompletos + '%'
          uniqueArray[i]['convencimientoMerca']         = convencimientoMerca + '%'
          uniqueArray[i]['convencimientoSucursal']      = convencimientoSucursal + '%'

          let convencimiento = contactos > 0 ? (( inscritos / contactos ) * 100 ).toFixed( 2 ) : 0

          uniqueArray[i]['convencimiento']    = convencimiento + '%'
          uniqueArray[i]['desglose']          = `( Inscritos( ${inscritos} ) / Contactos( ${contactos} ) ) * 100 `
          uniqueArray[i]['inscritos']         = inscritos
          uniqueArray[i]['inscritos_detalle'] = inscritosAlumnos // this.contactosInscritos.filter( el => el.id_usuario_ultimo_cambio == iderp )
          uniqueArray[i]['inscritos_fecha']   = this.filterVendedoras2.filter( el => el.id_usuario_ultimo_cambio == iderp )

          // Primero, agregarmos las ventas del KPI al momento
          uniqueArray[i]['ventas_momento'] = this.totalMatriculas.filter( el => el.id_usuario_ultimo_cambio == iderp ).length
          uniqueArray[i]['porcentajeCompletos'] = (( completos.length / contactos ) * 100 ).toFixed( 2 )

          if( iderp == 2785 ){
            console.log( '2785', vendedora )
            console.log( uniqueArray[i]['ventas_momento']  )
            console.log( this.totalMatriculas.filter( el => el.id_usuario_ultimo_cambio == iderp ) )
          }

        }

        // Buscar la vendedora que mejor se acomode
        // Ordenar por % de convencimiento (desc) y luego por carga laboral (asc)
        uniqueArray.sort((a, b) =>
          b.convencimiento - a.convencimiento || parseFloat(a.contactos) - parseFloat(b.contactos)
        );

        // Agregar ranking y determinar si pueden recibir más contactos
        uniqueArray.forEach((vendedora, index) => {
          vendedora.puedeRecibir = (vendedora.contactos ) <= 5;
        });

        let contador3 = 0
        uniqueArray.forEach((vendedora, index) => {
          vendedora.ranking = vendedora.puedeRecibir ? contador3 + 1 : 0  ;
          contador3 += vendedora.puedeRecibir ? 1 : 0
        });

        let contador = uniqueArray.filter( el => el.ranking ).length
        uniqueArray.forEach((vendedora, index) => {
          vendedora.ranking = vendedora.ranking ? vendedora.ranking : contador + 1  ;
          contador += vendedora.ranking ? 1 : 0
        });


        // Ordenamos por ventas en kpi
        uniqueArray.sort((a, b) => b.ventas_momento - a.ventas_momento);
        for( const i in uniqueArray ){

          uniqueArray[i]['position_ventas_momento'] = parseInt( i ) + 1

        }


        // Ahora ordenamos por contactos
        uniqueArray.sort((a, b) => b.contactos - a.contactos);

        for( const i in uniqueArray ){

          uniqueArray[i]['position'] = parseInt( i ) + 1

        }


        for( const i in uniqueArray ){

          const { contactosGeneral, position_ventas_momento, position } = uniqueArray[i]


          uniqueArray[i]['TWILIO CDMX'] = contactosGeneral.filter( el => el.sistema == 'TWILIO CDMX' ).length

          uniqueArray[i]['TWILIO GUADALAJARA'] = contactosGeneral.filter( el => el.sistema == 'TWILIO GUADALAJARA' ).length

          uniqueArray[i]['TWILIO MONTERREY'] = contactosGeneral.filter( el => el.sistema == 'TWILIO MONTERREY' ).length

          uniqueArray[i]['TWILIO CRM INBI'] = contactosGeneral.filter( el => el.sistema == 'TWILIO CRM INBI' ).length

          uniqueArray[i]['SUCURSAL EXTERNO'] = contactosGeneral.filter( el => !el.sistema  ).length

          uniqueArray[i]['TODOS'] = contactosGeneral.length

          uniqueArray[i]['diferencia'] = position - position_ventas_momento
        }

        // Solo sumatoria: TOTAL = suma de filas por ciudad × vendedora / ciudad × contacto
        const totalesCiudad = this.escuela === 2
          ? [
              this.buildFilaTotalPorCiudad('FAST', uniqueArray),
              this.buildFilaTotalPorCiudad('TODAS', uniqueArray),
            ]
          : [
              this.buildFilaTotalPorCiudad('Monterrey', uniqueArray),
              this.buildFilaTotalPorCiudad('CDMX', uniqueArray),
              this.buildFilaTotalPorCiudad('GDL', uniqueArray),
              this.buildFilaTotalPorCiudad('TODAS', uniqueArray),
            ]

        uniqueArray.push(...totalesCiudad)

        return uniqueArray

      },

      filterTablaContactos( ){

        let data = this.tablaContactos

        if( this.opZona != 'TODOS'){
          data = data.filter( el => el.sistema == this.opZona )
        }

        return data
      },

      headers2 ( ){

        let array = [
          { text: "Position"               , value: "position"                },
          { text: "Vendedora"              , value: "vendedora"               },
          { text: "Ciudad"                 , value: "estado"                  },
          { text: "Ventas al momento"      , value: "position_ventas_momento" },
          { text: "Diferencia"             , value: "diferencia"              },
          { text: "Calidad"                , value: "calidad"                 },
        ]

        if( this.checkGeneral ){
          array.push(
            { text: "Contactos rango Fecha"  , value: "contactos"      },
            { text: "Insc. General"          , value: "inscritos"      },
            { text: "Conv. General"          , value: "convencimiento", align: 'end' },
          )
        }

        if( this.checkCompletos ){
          array.push(
            { text: "Contactos completos"    , value: "completos"               },
            { text: "Insc. Completo"         , value: "inscritosCompletos"      },
            { text: "Conv. Completos"        , value: "convencimientoCompletos", align: 'end' },
          )
        }

        if( this.checkIncompletos ){
          array.push(
            { text: "Contactos incompletos"  , value: "incompletos"               },
            { text: "Insc. Incompleto"       , value: "inscritosIncompletos"      },
            { text: "Conv. Incompletos"      , value: "convencimientoIncompletos", align: 'end' },
          )
        }

        if( this.checkMerca ){
          array.push(
            { text: "Contactos MKT"          , value: "merca"               },
            { text: "Insc. Merca"            , value: "inscritosMerca"      },
            { text: "Conv. Merca"            , value: "convencimientoMerca", align: 'end' },
          )
        }

        if( this.checkSucursal ){
          array.push(
            { text: "Contactos Suc."         , value: "sucursal"               },
            { text: "Insc. Sucursal"         , value: "inscritosSucursal"      },
            { text: "Conv. Sucursal"         , value: "convencimientoSucursal", align: 'end' },
          )
        }


        array.push(
          // { text: "% MKT"                  , value: "porcentajemkt"  },
          // { text: "% Total"                , value: "porcentajeCompletos" },
        )

        return array
      }


    },

    watch: {
      dialogUsuario(val) {
        val || this.close();
      },
    },

    async created() {
      await this.initialize();
      await this.getFuntes()
      await this.getDetallesFuente()
      await this.getCampanias()
      await this.getVendedoras()
      await this.getVendedoras2()
      await this.getCursosEscuela()
      await this.getComoNosConocio()
    },

    //Methods
    methods: {
      /**
       * Sumatoria TOTAL por ciudad del CONTACTO (estado del prospecto),
       * no por ciudad de la vendedora.
       */
      buildFilaTotalPorCiudad(ciudad, filasVendedora) {
        const PUESTOS_MERCA = [25, 48, 49, 54, 62, 74, 97, 101]
        const filas = (filasVendedora || []).filter(v => v.vendedora !== 'TOTAL')
        const ciudadNorm = String(ciudad || '').toLowerCase()

        // Todos los contactos de la tabla, luego filtro por ciudad del contacto
        const todosContactos = filas.flatMap(v =>
          Array.isArray(v.contactosGeneral) ? v.contactosGeneral : []
        )
        const contactosCiudad = ciudad === 'TODAS'
          ? todosContactos
          : todosContactos.filter(c => String(c.estado || '').toLowerCase() === ciudadNorm)

        const esTwilio = (el) => String(el.nombre_completo || '').match(/TWILIO/)
        const esCompleto = (el) => String(el.nombre_completo || '').match(/TWILIO COMPLETO/)
        const esIncompleto = (el) => String(el.nombre_completo || '').match(/TWILIO INCOMPLETO/)
        const esMerca = (el) => !esTwilio(el) && PUESTOS_MERCA.includes(el.idpuesto)
        const esSucursal = (el) => !esTwilio(el) && !PUESTOS_MERCA.includes(el.idpuesto)

        const completos = contactosCiudad.filter(esCompleto)
        const incompletos = contactosCiudad.filter(esIncompleto)
        const merca = contactosCiudad.filter(esMerca)
        const sucursal = contactosCiudad.filter(esSucursal)

        const alumnosDe = (arr) => arr
          .filter(c => c.mialumno)
          .flatMap(c => Array.isArray(c.mialumnos) ? c.mialumnos : [])

        const inscritosCompletos = alumnosDe(completos)
        const inscritosIncompletos = alumnosDe(incompletos)
        const inscritosMerca = alumnosDe(merca)
        const inscritosSucursal = alumnosDe(sucursal)
        const inscritosDetalle = [
          ...inscritosCompletos,
          ...inscritosIncompletos,
          ...inscritosMerca,
          ...inscritosSucursal,
        ]
        const inscritos = inscritosDetalle.length
        const contactos = contactosCiudad.length

        const pct = (num, den) => den > 0 ? ((num / den) * 100).toFixed(2) + '%' : '0.00%'

        return {
          vendedora: 'TOTAL',
          estado: ciudad,
          contactos,
          contactosall: contactosCiudad,
          contactosGeneral: contactosCiudad,
          iderp: 0,
          inscritosCompletos,
          inscritosIncompletos,
          inscritosMerca,
          inscritosSucursal,
          convencimientoCompletos: pct(inscritosCompletos.length, completos.length),
          convencimientoIncompletos: pct(inscritosIncompletos.length, incompletos.length),
          convencimientoMerca: pct(inscritosMerca.length, merca.length),
          convencimientoSucursal: pct(inscritosSucursal.length, sucursal.length),
          convencimiento: pct(inscritos, contactos),
          desglose: `( Inscritos( ${inscritos} ) / Contactos( ${contactos} ) ) * 100 `,
          inscritos,
          inscritos_detalle: inscritosDetalle,
          inscritos_fecha: 0,
          ventas_momento: 0,
          porcentajeCompletos: 0,
          completos,
          incompletos,
          merca,
          sucursal,
          completosNumero: completos.length,
          incompletosNumero: incompletos.length,
          mercaNumero: merca.length,
          sucursalNumero: sucursal.length,
        }
      },

      /** Valida TOTAL por ciudad del contacto (no de la vendedora) */
      validarSumatoriaTotales(filasVendedora, filasTotales) {
        try {
          const filas = (filasVendedora || []).filter(v => v.vendedora !== 'TOTAL')
          const getTotal = (ciudad) => (filasTotales || []).find(t => t.estado === ciudad) || { contactos: 0 }

          const todosContactos = filas.flatMap(v =>
            Array.isArray(v.contactosGeneral) ? v.contactosGeneral : []
          )
          const porCiudadContacto = (ciudad) =>
            ciudad === 'TODAS'
              ? todosContactos
              : todosContactos.filter(c =>
                String(c.estado || '').toLowerCase() === String(ciudad).toLowerCase()
              )

          const ciudades = this.escuela === 2 ? ['FAST'] : ['Monterrey', 'CDMX', 'GDL']
          const report = { ok: true, detalle: [] }

          for (const ciudad of ciudades) {
            const esperados = porCiudadContacto(ciudad).length
            const totalRow = Number(getTotal(ciudad).contactos) || 0
            const tipos = getTotal(ciudad)
            const sumaTipos =
              (tipos.completos && tipos.completos.length || 0) +
              (tipos.incompletos && tipos.incompletos.length || 0) +
              (tipos.merca && tipos.merca.length || 0) +
              (tipos.sucursal && tipos.sucursal.length || 0)

            if (esperados !== totalRow) {
              report.ok = false
              report.detalle.push(`FUGA ${ciudad}: contactos por ciudad=${esperados} TOTAL=${totalRow}`)
            }
            if (totalRow !== sumaTipos) {
              report.ok = false
              report.detalle.push(`FUGA tipos ${ciudad}: contactos=${totalRow} tipos=${sumaTipos}`)
            }
          }

          const sumaCiudades = ciudades.reduce((a, c) => a + (Number(getTotal(c).contactos) || 0), 0)
          const totalTodas = Number(getTotal('TODAS').contactos) || 0
          if (sumaCiudades !== totalTodas) {
            report.ok = false
            report.detalle.push(
              `FUGA TODAS: suma ciudades=${sumaCiudades} TODAS=${totalTodas} (contactos Sin estado u otra ciudad)`
            )
          }

          const idsEnTabla = new Set(filas.map(v => Number(v.iderp)))
          const huerfanos = (this.prospectos || []).filter(p => !idsEnTabla.has(Number(p.usuario_asignado))).length
          if (huerfanos > 0) {
            report.ok = false
            report.detalle.push(`FUGA: ${huerfanos} prospectos fuera de lista de vendedoras`)
          }

          if (report.ok) {
            console.log('[sumatoria] OK por ciudad del contacto', {
              ciudades: Object.fromEntries(ciudades.map(c => [c, getTotal(c).contactos])),
              TODAS: totalTodas,
            })
          } else {
            console.warn('[sumatoria] Revisar fugas:', report.detalle)
          }
        } catch (e) {
          console.warn('[sumatoria] no se pudo validar', e)
        }
      },

      setFilasTotales(data){
        if (data && data.length > 0) {
          this.filasTotales = data.filter(el => el.vendedora === 'TOTAL')
        }
      },
      closeDialogEtiquetas(){
        this.dialogEtiquetas = false
      },
      //Obtener prospectos y usuarios
      async initialize() {
        this.cargar = true
        await this.getVendedoras();
        await this.getVendedoras2();

        const idsActivas = (this.filterVendedoras2 || [])
          .map((v) => Number(v.iderp))
          .filter((id) => Number.isFinite(id) && id > 0)

        await this.getProspectosAllCambiar();

        const huboReasignacion = await this.reasignarBajasSiAplica(idsActivas)
        if (huboReasignacion) {
          await this.getProspectosAllCambiar()
        }

        this.cargar = false
      },

      async reasignarBajasSiAplica(idsActivas) {
        if (!idsActivas || !idsActivas.length) return false

        const setActivas = new Set(idsActivas.map(Number))
        const hayBajas = (this.prospectos || []).some((p) => {
          const id = Number(p.usuario_asignado)
          return Number.isFinite(id) && id > 0 && !setActivas.has(id)
        })
        if (!hayBajas) return false

        const activas = (this.filterVendedoras2 || []).map((v) => ({
          iderp: Number(v.iderp),
          nombre: v.nombre || v.nombre_completo || 'Sin nombre',
          estado: v.estado || 'Sin estado',
          idplantel: v.idplantel != null ? Number(v.idplantel) : null,
        }))

        try {
          const response = await this.$http.post('cambiar.prospecto.reasignar.bajas', {
            escuela: this.escuela,
            fechaini: this.fechaini,
            fechafin: this.fechafin,
            idsActivas,
            activas,
          })
          const data = response.data || {}
          if (data.reasignados > 0) {
            this.validarSuccess(
              `Se reasignaron ${data.reasignados} prospectos de baja a quien tiene mayor % de asignación en la sucursal`
            )
            return true
          }
        } catch (error) {
          const msg =
            error && error.response && error.response.data && error.response.data.message
              ? error.response.data.message
              : 'Error al reasignar bajas'
          this.validarError(msg)
        }
        return false
      },

      getProspectosAllCambiar(){

        this.cargar = true
        const payload = {
          fechaini: this.fechaini,
          fechafin: this.fechafin,
          escuela : this.escuela
        }

        return this.$http.post("cambiar.prospecto.obtener.prospecto", payload ).then((response) => {
          this.contactosActivos   = response.data.contactosActivos;
          this.contactosVsFecha   = response.data.contactosVsFecha;
          this.contactosInscritos = response.data.contactosInscritos;
          this.prospectos         = response.data.prospectos;
          this.baseEscuela        = response.data.baseEscuela
          this.totalMatriculas    = response.data.totalMatriculas

          this.baseEscuela.push({ base: '', escuela: 0, zona: 'TODOS' },)
          this.cargar = false

          for( const i in this.prospectos ){

            const { nombre_completo } = this.prospectos[i]

            this.prospectos[i]['completo'] = nombre_completo.match('INCOMPLETO') ? '🧊' : '🔥'

          }
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })
      },

      // getVendedoras() {
      //   this.usuarios = []
      //   return this.$http.get("cambiar.prospecto.obtener.vendedora").then((response) => {
      //     this.usuarios = response.data;
      //   }).catch( error =>{
      //     this.validarError( error.response.data.message )
      //   }).finally( () => { this.cargar = false })
      // },

      //Cerrar Dialog Vendedora
      close() {
        this.dialogUsuario = false;
        this.dialog        = false;
      },

      //Modificar este para ver si funciona, esta traido de ActivarProspectos
      actualizar() {
        this.prospecto.usuario_asignado = this.usuario;
        this.cargar = true
        return this.$http.post("cambiar.prospecto.updateprospectovendedora", this.prospecto).then((response) => {
          this.dialogUsuario = false;
          this.cargar = false
          this.prospecto = null;
          this.initialize();
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })
      },

      verContactos( value ){

        this.tablaContactos = value
        this.dialogMensajes     = true

      },

      verInscritos( value ){

        this.tablaAlumnos   = value
        this.dialogAlumnos  = true

      },

      previewLink( item ){
        window.open(item.ReferralSourceUrl, '_blank')

      },

      verEnWEB( item ){

      },



    },
  };
</script>
<style>



  #asignacion td:nth-child(5) {
    background-color: #E8E8E8 !important;
  }

  #asignacion td:nth-child(6) {
    background-color: #E8E8E8 !important;
  }

  #asignacion td:nth-child(7) {
    background-color: #E8E8E8 !important;
  }


  #asignacion td:nth-child(11) {
    background-color: #E8E8E8 !important;
  }

  #asignacion td:nth-child(12) {
    background-color: #E8E8E8 !important;
  }

  #asignacion td:nth-child(13) {
    background-color: #E8E8E8 !important;
  }


  #asignacion td:nth-child(17) {
    background-color: #E8E8E8 !important;
  }
  #asignacion td:nth-child(18) {
    background-color: #E8E8E8 !important;
  }
  #asignacion td:nth-child(19) {
    background-color: #E8E8E8 !important;
  }



</style>
